import axiosHelper from "../../../../axiosHelper";
import { APIUSEROLD, API_FAILURE, GET_ALL_EMAIL_TRACK_MASTER } from "../../../../config/constants";
import { apiErrors } from "../../../../helper";

export function fetchAllEmailTrackingList(filter, callback) {
  
    return (dispatch) => {
      const request = axiosHelper.get(`${APIUSEROLD.getAllEmailTrackingList}`, {
        params: {
          page: filter.current_page,
          pageSize: filter.per_page,
          recipientEmail:filter?.RecipentEmail,
          emailType:filter?.EmailType,
          RequestFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
          RequestToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
          // SearchType: filter?.sortField?.supplierName,
          // SortBy: filter?.sortField,
          // SortOrder: filter.sortOrder,
        }, // Assuming filter contains necessary query parameters
      });
      request
        .then((response) => {
          
            // 
          if (response?.data || response.status === 204) {
            dispatch({
              type: GET_ALL_EMAIL_TRACK_MASTER,
              payload: {
                data: response.status === 204 ? [] : response?.data?.Data,
  
                filter, // Include filter in payload
              },
            });
             callback(response, null);
          }
        })
        .catch((error) => {
          dispatch({ type: API_FAILURE });
          if (error.response.status === 401) {
            apiErrors(error)
        } else{
    
          callback(null, error);
        }
          // apiErrors(error);
        });
    };
  }